import graphql__3ad96350fd9294e1e04a from "./__generated__/SubmitCommentMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__3ad96350fd9294e1e04a;

function submitComment(commentable, comment, onCompleted, { anonymous = false } = {}) {
  const variables = {
    commentableId: commentable.id,
    content: comment,
    anonymous
  };

  const configs = [
    {
      type: "RANGE_ADD",
      parentID: commentable.id,
      connectionInfo: [
        {
          key: "CommentsPanel_comments",
          rangeBehavior: "prepend"
        }
      ],
      edgeName: "newCommentEdge"
    }
  ];

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error),
    configs
  });
}

export { submitComment };
